﻿import { events } from "@tools";
import { Directive } from "@app/components/directive";
import { Dirs } from "@app/helpers/dirs";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IRootScope } from "@models";
import { DialogService } from "@app/services/dialog.service";

@NgComponent({
    token: Token.KbAvatar,
    dependencies: [
        Token.$RootScope,
        Token.DialogService,
        Token.$Http,
    ]
})
export class KbAvatar extends Directive {
    constructor(
        private $rootScope: IRootScope,
        private dialogService: DialogService,
        private $http: ng.IHttpService
    ) {
        super();

        this.replace = true;
        this.template = Dirs.component("kb-avatar");
        this.restrict = "E";
        this.scope = {
            path: "="
        };

        this.link = (scope, element, atts) => {
            $rootScope.$on(events.avatarChanged, (e, newPath) => {
                // Adding a hash to force the model to change (otherwise the image will not
                // auto-load, assuming the newPath has not changed (but the data has)
                (scope as any).path = newPath + "#" + (new Date()).getTime().toString();
            });
        };
    }

}
